module.exports = __webpack_public_path__ + "img/international-consulting.5f83f87c.png";